import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';

import { Error404Component } from './@core/modules/error-handler/components/error404/error404.component';
import { AuthGuard, PageAccessGuard } from './@core/auth/services';


const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'admin', pathMatch: 'full',  canActivate : [AuthGuard] },
      {
        path: 'login',
        loadChildren: () => import('./pages/Auth/auth.module').then((a) => a.AuthModule),
      },
      {
        path: 'workflow',
        loadChildren: () => import('./pages/workFlowModule/work-flow/work-flow.module').then((a) => a.WorkFlowModule),
        canActivate : [AuthGuard, PageAccessGuard]
      },
      {
        path: 'admin',
        loadChildren: () => import('./pages/administaration/administration.module').then(m => m.AdministrationModule),
        canActivate : [AuthGuard]
      },
    ],
  },
  { path: '**', redirectTo: '' },
  { path: 'error/404', component: Error404Component },
];



// const routes: Routes = [
//   {
//     path: 'pages',
//     loadChildren: () => import('./pages/pages.module')
//       .then(m => m.PagesModule),
//   },
//   {
//     path: 'auth',
//     component: NbAuthComponent,
//     children: [
//       {
//         path: '',
//         component: NbLoginComponent,
//       },
//       {
//         path: 'login',
//         component: NbLoginComponent,
//       },
//       {
//         path: 'register',
//         component: NbRegisterComponent,
//       },
//       {
//         path: 'logout',
//         component: NbLogoutComponent,
//       },
//       {
//         path: 'request-password',
//         component: NbRequestPasswordComponent,
//       },
//       {
//         path: 'reset-password',
//         component: NbResetPasswordComponent,
//       },
//     ],
//   },
//   { path: '', redirectTo: 'pages', pathMatch: 'full' },
//   { path: '**', redirectTo: 'pages' },
//   { path: 'error/404', component: Error404Component },

// ];

const config: ExtraOptions = {
  useHash: false,
  enableTracing: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
